export default __webpack_public_path__ + "static/media/icons8-dev-post.15a5555a.svg";